import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { BaseComponentProps } from "../types";
import { baseAttrs } from "../utils";

export type CardProps = BaseComponentProps & {
	children?: ReactNode;
};

/**
 * @deprecated Use the `Card` primitive from `@portal/components/primitives/Card` instead.
 * Part of the card consolidation onto the CVA-driven `Card`/`MetricCard` primitives.
 */
export const Card = ({ testId, className, children }: CardProps) => {
	return (
		<div
			{...baseAttrs({
				testId,
				className: cn(
					"w-full h-fit min-h-fit border border-gray-200 rounded-md bg-white z-2",
					className,
					"relative",
				),
			})}
		>
			{children}
		</div>
	);
};
